import {getField, updateField} from 'vuex-map-fields';
import * as API from '@/api';

function initialState () {
  return {
    affiliation:null,
    key:'mewAff'
  };
}

const state = initialState ();

// actions

const actions = {
  async set (context, payload) {
    let response = await context.dispatch ('updateHits', payload);
    context.commit ('set_affiliation', response.affiliation);
    return response;
  },
  async reset (context, payload) {
    await context.commit ('reset', payload);
  },
  async updateHits(context, payload){
    var response = await API.affiliation.updateHits (payload);
    return response;
  }
};

// getters
const getters = {
    get: (state, getters, rootState) => {
        if (state.affiliation) {
            return state.affiliation;
        }
        let aff = localStorage.getItem(state.key)
        if (aff) {
          return JSON.parse(aff);
        }
    },
};

// mutations
const mutations = {
  updateField,
  set_affiliation (state, payload) {
    let affiliation = {};

    affiliation.code = payload.code;
    affiliation.timestamp = (Date.now()/1000); // Current timestamp in sec
    state.affiliation = affiliation;
    localStorage.setItem(state.key,JSON.stringify(affiliation));
  },
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });

    localStorage.removeItem(state.key);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
